import { render } from "./ExternalViewer.vue?vue&type=template&id=2e933088&scoped=true"
import script from "./ExternalViewer.vue?vue&type=script&lang=js"
export * from "./ExternalViewer.vue?vue&type=script&lang=js"

import "./ExternalViewer.vue?vue&type=style&index=0&id=2e933088&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e933088"]])

export default __exports__